import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {InsuranceCompany} from '../../../shared/interface/insurance-company';
import {InsuranceCompanyService} from '../../../shared/services/insurance-company.service';
import {Dictionary} from '../../../shared/interface/dictionary';
import {
  COMPANY_ASF,
  COMPANY_ASF_PREMIUM, COMPANY_MULTISFERA,
} from '../../../shared/services/dict.service';
import {FormBuilder, FormControl} from '@angular/forms';
import {AuthService} from '../../../shared/services/auth.service';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AvatarCropDialogComponent} from '../../user/avatar-crop-dialog/avatar-crop-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {Uuid} from '../../../shared/interface/response/uuid';
import {JobResultDialogComponent} from '../../../shared/components/job-result-dialog/job-result-dialog.component';

@Component({
  selector: 'app-insurance-company-details',
  templateUrl: './insurance-company-details.component.html',
  styleUrls: ['./insurance-company-details.component.scss']
})
export class InsuranceCompanyDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @ViewChild('imageSelect') imageSelect: ElementRef;

  companyId?: string = null;
  company: ReplaySubject<InsuranceCompany> = new ReplaySubject(1);
  companyObject?: InsuranceCompany = null;
  modifyBoolean = false;
  hasAsf = false;
  hasAsfPremium = false;
  hasMultisfera = false;
  imgCnt = 0;
  imageSelectControl: FormControl;
  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private route: ActivatedRoute,
    private insuranceCompanyService: InsuranceCompanyService,
    private snack: MatSnackBar,
    private fb: FormBuilder,
    private auth: AuthService,
    private dialog: MatDialog,
  ) {
    this.imageSelectControl = fb.control('');
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.companyId = params.id;
        this.loadCompany();
      });

    this.imageSelectControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: any) => {
        if (!this.imageSelect.nativeElement.files[0]) {
          return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(this.imageSelect.nativeElement.files[0]);
        reader.onload = () => {
          const fileBase64 = reader.result.toString();
          const dialogRef = this.dialog.open(AvatarCropDialogComponent, {
            width: '55%',
            data: {fileBase64, ratio: 1, roundCropper: false, maintainRatio: false, compressedFile: false},
            height: '610px',
            maxHeight: '90%',
            panelClass: 'full-height-dialog',
          });

          dialogRef.afterClosed().subscribe(result => {
            if (!result) {
              this.imageSelectControl.reset();
              return;
            }

            this.insuranceCompanyService.updateImage(this.companyObject.id, result)
              .subscribe(() => {
                this.snack.open('Pomyślnie zmieniono zdjęcie', '', {duration: 2000});
                this.imgCnt++;
                this.imageSelectControl.reset();
                this.loadCompany();
              }, (error: HttpErrorResponse) => {
                this.snack.open('Przy aktualizacji zdjęcia wystąpił błąd', error.status.toString(), {duration: 2000});
                this.imageSelectControl.reset();
              });
          });
        };
      });
  }

  loadCompany(): void {
    this.insuranceCompanyService.get(this.companyId).subscribe((company: InsuranceCompany) => {
      this.company.next(company);
      this.companyObject = company;
      this.companyObject.companies.forEach((e: Dictionary) => {
        if (e.key === COMPANY_ASF) {
          this.hasAsf = true;
        }

        if (e.key === COMPANY_ASF_PREMIUM) {
          this.hasAsfPremium = true;
        }
        if (e.key === COMPANY_MULTISFERA) {
          this.hasMultisfera = true;
        }
      });
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych TU', error.status.toString(), {
        duration: 2000
      });
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  setImage(): void {
    const e: HTMLElement = this.imageSelect.nativeElement;
    e.click();
  }
  modify(): void {
    this.modifyBoolean = true;
  }

  toggleRegistrations(): void {
    this.insuranceCompanyService.updateBlockRegistrations(this.companyObject.id, !this.companyObject.blockRegistrations)
      .subscribe((response: Uuid) => {
        const dialogRef = this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });

        dialogRef.afterClosed().subscribe(result => {
          this.loadCompany();

          if (result) {
            this.snack.open('Zaktualizowano blokadę rejestracji', '', {duration: 2000});
          }
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy aktualizacji blokady rejestracji wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }
  copyMessage(val: string): void{
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snack.open('Skopiowano do schowka', '', {duration: 2000});

  }

  floor(num: number): number {
    return Math.floor(num);
  }
}
